<template>
  <div class="container big bb">
    <el-switch
      v-model="inquiry_auth"
      active-text="开启视频权限"
      inactive-text="关闭视频权限"
      @change="setClinicVideoInquiry"
    ></el-switch>
    <div class="flex align-center" style="margin-top: 20px">
      <div>关联云药房：</div>
      <el-select
        v-model="ref_hospital_list"
        multiple
        filterable
        remote
        placeholder="请输入药房名"
        style="width: 400px; margin-right: 10px"
        :remote-method="remoteMethod"
        value-key="hospital_id"
      >
        <el-option
          v-for="item in hospitalList"
          :key="item.hospital_id"
          :label="item.hospital_name"
          :value="item"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="setRefHospital">保存</el-button>
    </div>
    <div class="flex align-center" style="margin-top: 20px">
      <div>开方云药房：</div>
      <el-select
        v-model="prescription_hospital_id"
        remote
        placeholder="请输入药房名"
        style="width: 400px; margin-right: 10px"
        :remote-method="remoteMethod"
      >
        <el-option
          v-for="item in hospitalList"
          :key="item.hospital_id"
          :label="item.hospital_name"
          :value="item.hospital_id"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="setPreHospital">保存</el-button>
    </div>
    <div style="margin-top: 20px">
      <span>诊所的医生，通过医生端APP只能查看开方云药房</span>
      <el-switch
        v-model="open_app"
        active-color="#669961"
        style="margin-left: 10px"
        @change="setClinicDoctorOpen"
      >
      </el-switch>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inquiry_auth: false,
      ref_hospital_list: [], //关联的药房
      prescription_hospital_id: '', //开方的药房
      hospitalList: [], //药房列表
      detail: {},
      open_app: ''
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    //获取药房详情
    getDetail() {
      let hospital_id = this.$route.query.hospital_id;
      this.axios
        .post('platform/clinic/getClinicInfo', { hospital_id })
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.info;
            this.inquiry_auth = data.inquiry_auth == 1 ? true : false;
            this.open_app = data.open_app == 1 ? true : false;
            this.ref_hospital_list = data.ref_hospital_list || [];
            this.prescription_hospital_id = data.prescription_hospital_id || '';
            this.detail = data.info;
            this.remoteMethod('');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //设置视频
    setClinicVideoInquiry() {
      let data = {
        inquiry_auth: this.inquiry_auth ? 1 : 0,
        hospital_id: this.$route.query.hospital_id
      };
      this.axios
        .post('platform/clinic/setClinicVideoInquiry', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.getDetail();
          }
        });
    },
    //远程搜索
    remoteMethod(query) {
      let data = {
        hospital_name: query,
        page: 1,
        pageNumber: 100
      };
      this.axios.post('platform/hospital/getHospitaList', data).then((res) => {
        let list = res.data.list.map((item) => {
          return {
            hospital_id: item.hospital_id,
            hospital_name: item.hospital_name
          };
        });
        this.hospitalList = list;
      });
    },
    //设置关联云药房
    setRefHospital() {
      this.$confirm('变更药房可能导致pad无法正常工作，请谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            ref_hospital_id: '',
            hospital_id: this.$route.query.hospital_id
          };
          if (this.ref_hospital_list.length > 0) {
            let arr = [];
            this.ref_hospital_list.forEach((ele) => {
              if (ele.hospital_id) {
                arr.push(ele.hospital_id);
              }
            });
            data.ref_hospital_id = arr.toString();
          }
          return this.axios.post('platform/clinic/setRefHospital', data);
        })
        .then((res) => {
          this.$message.success('修改成功');
        });
    },
    //设置开方云药房
    setPreHospital() {
      if (!this.prescription_hospital_id) {
        this.$message.error('请选择开方云药房');
        return false;
      }
      let data = {
        prescription_hospital_id: this.prescription_hospital_id,
        hospital_id: this.$route.query.hospital_id
      };
      this.axios
        .post('platform/clinic/setPrescriptionHospital', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
          }
        });
    },
    //设置诊所医生查看云药房权限
    setClinicDoctorOpen() {
      let data = {
        open_app: this.open_app ? 1 : 0,
        clinic_id: this.$route.query.hospital_id
      };
      this.axios
        .post('platform/clinic/setClinicDoctorOpen', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.getDetail();
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
}
</style>
